<script>
  import { assignGovernorFills } from '../utils/assign-governor-fills.js';

  export let feed;

  const rows = [
    0,
    39.121,
    78.242,
    117.362,
    156.483,
    195.603,
    234.724,
  ];

  const columns = [
    { x: 0, start: 4, seats: [7, 1, 2] },
    { x: 39.859, start: 3, seats: [8, 9, 3, 4] },
    { x: 79.718, start: 2, seats: [10, 11, 12, 5, 6] },
    { x: 119.577, start: 1, seats: [13, 14, 15, 16] },
    { x: 159.436, start: 1, seats: [17, 18, 19] },
    { x: 199.295, start: 0, seats: [20, 21, 22] },
    { x: 239.154, start: 0, seats: [23, 24, 25] },
    { x: 279.418, start: 0, seats: [26, 27, 28] },
    { x: 319.276, start: 0, seats: [29, 30, 31] },
    { x: 359.135, start: 1, seats: [32, 33, 34] },
    { x: 398.994, start: 1, seats: [35, 36, 37, 38] },
    { x: 438.853, start: 2, seats: [39, 40, 41, 43, 44] },
    { x: 478.712, start: 3, seats: [42, 45, 46, 47] },
    { x: 518.571, start: 4, seats: [48, 49, 50] },
  ];

  const seats = columns.flatMap(
    ({ x, start, seats: numbers }) =>
      numbers.map((n, row) => ({
        n,
        x,
        y: rows[start + row],
        party: n <= 24 ? 'dem' : 'gop',
        contested: n >= 7 && n <= 42,
      }))
  );

  $: seatLayout = assignGovernorFills(seats, $feed);
  $: fills = seatLayout.fills;
  $: borders = seatLayout.borders;
</script>

<div class="seat-chart seat-chart--governor">
  <svg
    id="governor-svg"
    class="seat-chart__svg"
    viewBox="0 0 555.514 270.983"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g id="governor-seats">
      <line
        id="governor-half-line"
        x1="277.7"
        y1="0"
        x2="277.7"
        y2="154.121"
      />

      {#each seats as seat (seat.n)}
        <rect
          data-seat={seat.n}
          class={`${fills.get(seat.n)} ${
            seat.contested
              ? borders.get(seat.n)
              : `no-contest-${seat.party}`
          }`}
          x={seat.x + (seat.contested ? 2 : 0.55)}
          y={seat.y + (seat.contested ? 2 : 0.55)}
          width={36.943 - (seat.contested ? 4 : 1.1)}
          height={36.259 - (seat.contested ? 4 : 1.1)}
        />
      {/each}
    </g>
  </svg>
</div>